// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qc_BEqJ67iMaiR9onJq9{padding:12px 8px 12px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputPadding": `Qc_BEqJ67iMaiR9onJq9`
};
export default ___CSS_LOADER_EXPORT___;
